import AIPlayerSettings from '@/components/settings/AIPlayerSettings'

const AIPlayerSettingsScreen = () => {
  return <AIPlayerSettings />
}

export default AIPlayerSettingsScreen
